import $ from 'jquery';
import Application from './application';
import LoginView from '../views/login';

/**
 * An application for user authentication.
 */
const LoginApplication = Application.extend({

    initialize: function () {
        this.on('start', this.renderView);
        Application.prototype.initialize.apply(this, arguments);
    },

    renderView: function () {

        const view = new LoginView({ el: '#body form' });

        // On login, redirect to the calling page or the main page of the site

        view.listenToOnce(view.model, 'sync', function () {
            window.location = document.referrer ||
                              this.$el.attr('data-front-door-url');
        });

        view.render();
    }
});

$(() => {
    const app = new LoginApplication();
    app.prepare().then((app) => { app.start(); });
});
